import { render, staticRenderFns } from "./check-shop.vue?vue&type=template&id=64ba215e&"
import script from "./check-shop.vue?vue&type=script&lang=js&"
export * from "./check-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports